import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import SPEC from '../apispec';

export default function ApiDocsContainer() {
	return <SwaggerUI spec={SPEC} />;
}
